import { required, prop } from '@rxweb/reactive-form-validators';

export class RoleModel {
    @required()
    name: string;

    @prop({ name: 'permissions' })
    permissions: any;
}
